/*
 * @Description: 收款报表详情
 * @Author: 李镇鹏
 * @Date: 2019-06-24 10:41:42
 * @LastEditTime: 2019-07-01 19:54:03
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import { Form,Button,message,Col, Row,Input } from 'antd';
import SuperForm from '../../../../components/SuperForm';
import TableDOM from '../../../../components/Table';
import AuthButton from '../../../../components/AuthButton/AuthButton';
import {post, config, transterQuery, postFrom} from '../../../../axios';
import DetailTitle from '../../../../components/DetailTitle/index';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import ModalDom from '../../../../components/Modal';
import {dicPayChannel, dicPayType, ReceivablesType} from '../../../../axios/dictionaries';
import moment from 'moment';
import {handleExportParams, moneyAddComma} from '../../../../utils';

class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                customerName: '',
                customerPhone: '',
                feeName: '',
                houseId: '',
                orderNoThird: '',
                payChannel: '',
                payType: '',
                startDate: '',
                endDate: '',
                pageSize: 10,
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            tableTotalMny: 0, //表格总金额
            showSigningModal: false, //显示签约
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    loadPack = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            current = values.current
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true,current });

        postFrom({ url: config.API_house_findHouseBillPageList, data }).then(res => {
            this.setState({ tableTotalMny: res.money,tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    render() {
        let {
            current,
            tableData,
            tableLoading,
            tableTotal,
            tableTotalMny,
            params
        } = this.state;
        let { visible, handleCancel, form: { getFieldDecorator } } = this.props;

        return (
            <ModalDom
                title="详情"
                width="980px"
                loading={tableLoading}
                visible={visible}
                onCancel={()=>{
                    handleCancel();
                    this.setState({
                        params:{ //搜索参数
                            customerName: '',
                            customerPhone: '',
                            mustPayDate:'',
                            feeName: '',
                            houseId: '',
                            customerId:'',
                            orderNoThird: '',
                            payChannel: '',
                            payType: '',
                            // startDate: '',
                            // endDate: '',
                            pageSize: 10,
                        }
                    })
                }}
                footer={
                    <Button onClick={()=>{
                        handleCancel();
                        this.setState({
                            params:{ //搜索参数
                                customerName: '',
                                customerPhone: '',
                                mustPayDate:'',
                                feeName: '',
                                houseId: '',
                                orderNoThird: '',
                                payChannel: '',
                                payType: '',
                                // startDate: '',
                                // endDate: '',
                                pageSize: 10,
                            }
                        })
                    }}>关闭</Button>
                }
            >
                <div className="custom">
                    <Form labelCol={{ span: 0 }}
                          wrapperCol={{ span: 24 }}>
                        <Row>
                            <Col>
                                <DetailTitle title="房源" boxStyle={{ marginTop: 0 }} />
                                <CustomRow>
                                    <CustomCol label="项目" required={false} >
                                        {getFieldDecorator('projectKeyword', {
                                            rules: [{
                                                required: false, message: '请输入',
                                            }],
                                            initialValue: params.projectKeyword
                                        })(
                                            <Input
                                                disabled={true}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <DetailTitle title="查询" />
                <div className="search-wrapper search-wrapper-two" style={{ flexDirection: 'column' }}>
                    <SuperForm
                        onRef={ref => this.superFormRef = ref}
                        data={searchData(params)}
                        sumbit={this.loadPack}
                        addParams={'current'}
                    />
                    <div className="search-btn-list">
                        <AuthButton  authkey="z-7-1"   type="primary" icon="export" href={`${config.API_report_findHouseBillExprot}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                            导出
                        </AuthButton>
                    </div>
                </div>
                <TableDOM
                    columns={columns()}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    totalMny={tableTotalMny}
                    current={current}
                    onChange={this.loadPack}
                    scroll={{ x: 1200 }}
                />
            </ModalDom>
        )
    }
}

const searchData = (params) => {
    let data = [
        {
            tagName: 'MonthPicker',
            formConfig: { name: 'mustPayDate',options:{initialValue:moment(params.mustPayDate)}},
            attribute: { placeholder: '请选择应收月份',type:'month',format:"YYYY-MM", allowClear:false,style: { width: "172.7px" },disabled :true },
        }
    ];
    return data;
};

const columns = () => [
    {
        title: '楼栋',
        dataIndex: 'buildingName',
        width: 100
    },
    {
        title: '房号',
        dataIndex: 'roomNo',
        width: 50
    },
    {
        title: '应收金额',
        dataIndex: 'rent',
        width: 70
    },
    {
        title: '实收金额',
        dataIndex: 'rent',
        width: 100,
        render(text, record, index) {
            return record.status===1 ? record.rent : 0
        }
    },
    {
        title: '核销金额',
        dataIndex: 'rent',
        width: 100,
        render(text, record, index) {
            return record.writeOff===1 ? record.rent : 0
        }
    },
    {
        title: '空置账单金额',
        dataIndex: 'rent',
        width: 100,
        render(text, record, index) {
            return record.status===1 ?  '-' : record.rent
        }
    },
    {
        title: '账单状态',
        dataIndex: 'status',
        width: 100
        ,render: text => text===1?'已租':'空置'
    }
];
export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/DeviceBillReport/components/Detail/index.js